<!-- 生物催化酶 -->
<template>
	<CommonTablePage
		type="bioEnzyme"
		title-value="生物催化酶"
		placeholder="请输入重组酶名称"
		:columns="columns"
		api-type="bio_enzyme"
	/>
</template>

<script setup lang="ts">
import { ref } from "vue";
import CommonTablePage from "./components/CommonTablePage.vue";
defineOptions({
	name: "BioEnzyme"
});
const columns = ref([
	{
		prop: "recombinantEnzymeName",
		label: "重组酶名称"
	},
	{
		prop: "applicableField",
		label: "可应用领域/催化类型"
	},
	{
		prop: "applicationStatus",
		label: "应用状态"
	}
]);
</script>
